(() => {
  if (window.zb3FooterBooted) return;
  window.zb3FooterBooted = true;
  const initialized = new WeakSet();
  function init(scope) {
    const footers = scope.matches?.('[data-zb3-footer]') ? [scope] : scope.querySelectorAll('[data-zb3-footer]');
    footers.forEach(footer => {
      if (initialized.has(footer)) return;
      initialized.add(footer);
      const nav = footer.querySelector('[data-zb3-footer-tabs]');
      const tabs = [...footer.querySelectorAll('[data-zb3-footer-tab]')];
      const panels = [...footer.querySelectorAll('[data-zb3-footer-panel]')];
      const desktop = matchMedia('(min-width: 990px)');
      let selected = tabs[0]?.dataset.zb3FooterTab;
      function select(key, focus = false) {
        selected = key;
        tabs.forEach(tab => {
          const active = tab.dataset.zb3FooterTab === key;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.zb3FooterPanel !== key; panel.open = true; });
      }
      function mode() {
        if (desktop.matches) {
          footer.dataset.zb3FooterMode = 'tabs';
          nav.hidden = false;
          nav.setAttribute('role', 'tablist');
          nav.setAttribute('aria-orientation', 'vertical');
          tabs.forEach(tab => {
            tab.setAttribute('role', 'tab');
            const panel = panels.find(item => item.dataset.zb3FooterPanel === tab.dataset.zb3FooterTab);
            tab.setAttribute('aria-controls', panel.id);
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', tab.id);
          });
          select(selected);
        } else {
          footer.dataset.zb3FooterMode = 'disclosures';
          nav.hidden = true;
          nav.removeAttribute('role');
          panels.forEach((panel, index) => {
            panel.hidden = false;
            panel.open = index === 0;
            panel.removeAttribute('role');
            panel.removeAttribute('aria-labelledby');
          });
        }
      }
      nav.addEventListener('click', event => {
        const tab = event.target.closest('[data-zb3-footer-tab]');
        if (tab && desktop.matches) select(tab.dataset.zb3FooterTab);
      });
      nav.addEventListener('keydown', event => {
        if (!desktop.matches) return;
        const tab = event.target.closest('[data-zb3-footer-tab]');
        if (!tab) return;
        let index = tabs.indexOf(tab);
        if (event.key === 'ArrowDown') index = (index + 1) % tabs.length;
        else if (event.key === 'ArrowUp') index = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = tabs.length - 1;
        else return;
        event.preventDefault();
        select(tabs[index].dataset.zb3FooterTab, true);
      });
      desktop.addEventListener('change', mode);
      mode();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
